import { c as _c } from "react/compiler-runtime";
import { IconFlag, IconSearch } from "@tabler/icons-react";
import Link from "next/link";
import { Alert, AlertDescription } from "@domainstack/ui/alert";
export function RedirectedAlert(t0) {
  const $ = _c(17);
  let domain;
  let finalUrl;
  let props;
  if ($[0] !== t0) {
    ({
      domain,
      finalUrl,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = domain;
    $[2] = finalUrl;
    $[3] = props;
  } else {
    domain = $[1];
    finalUrl = $[2];
    props = $[3];
  }
  if (!finalUrl) {
    return null;
  }
  let dest;
  try {
    let t1;
    if ($[4] !== finalUrl) {
      t1 = new URL(finalUrl).hostname.replace(/^www\./i, "").toLowerCase();
      $[4] = finalUrl;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    dest = t1;
  } catch {
    return null;
  }
  const src = domain.replace(/^www\./i, "").toLowerCase();
  if (dest === src) {
    return null;
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconFlag aria-hidden={true} />;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = `/${encodeURIComponent(dest)}`;
  const t3 = `View report for ${dest}`;
  let t4;
  if ($[7] !== dest) {
    t4 = <span className="font-medium">{dest}</span>;
    $[7] = dest;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconSearch className="!size-3.5" aria-hidden={true} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t6 = <AlertDescription><p className="text-[13px]">We followed a redirect to{" "}<Link href={t2} className="inline-flex items-center gap-1 text-foreground/90 underline underline-offset-3 hover:text-muted-foreground" title={t3}>{t4}{t5}</Link>{"."}</p></AlertDescription>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props || $[15] !== t6) {
    t7 = <Alert {...props}>{t1}{t6}</Alert>;
    $[14] = props;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}